import "./scrollBox.scss";

// ScrollBox: reusable scrollable container with a themed custom scrollbar
// اسکرول‌باکس: کانتینر اسکرول‌پذیر قابل‌استفاده مجدد با اسکرول‌بار هماهنگ با تم
function ScrollBox({ children, height, className = "", ...rest }) {
  const style = height
    ? { height: typeof height === "number" ? `${height}px` : height }
    : undefined;

  return (
    <div className={`scroll-box ${className}`} style={style} {...rest}>
      {children}
    </div>
  );
}

export default ScrollBox;